"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _keyCodes = require("./keyCodes");

var navigateOnEnterOrSpace = function navigateOnEnterOrSpace(callback) {
  return function (e) {
    if (e.keyCode === _keyCodes.RETURN_KEY_CODE || e.keyCode === _keyCodes.SPACEBAR_KEY_CODE) {
      e.preventDefault();
      return callback(e);
    }

    return false;
  };
};

var _default = navigateOnEnterOrSpace;
exports["default"] = _default;